<template>
    <div class="border-t md:border border-dust md:px-2 flex justify-between items-center bg-cloud font-freizeit">
        <button
            type="button"
            :disabled="quantity === 1"
            @click="decreaseQuantity"
            aria-label="Decrease Quantity"
            :class="{ 'opacity-50 cursor-not-allowed': quantity === 1 }"
            class="p-2 text-2xl"
        >
            -
        </button>

        <p
            aria-label="Total Bottles"
            class="text-base"
        >
            {{ quantity }}
        </p>

        <button
            type="button"
            @click="increaseQuantity"
            aria-label="Increase Quantity"
            class="p-2 text-2xl"
        >
            +
        </button>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                quantity: 1,
            };
        },

        methods: {
            increaseQuantity() {
                this.quantity += 1;

                this.$emit('quantityChange', this.quantity);
            },

            decreaseQuantity() {
                this.quantity -= 1;

                this.$emit('quantityChange', this.quantity);
            },
        },
    };
</script>
